import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Modal, Radio, Steps, Tooltip, Rate, Card } from "antd";
import { CalendarFilled, InfoCircleFilled } from "@ant-design/icons";
import RDatePicker from "react-datepicker";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { Collapse } from "antd";
import axios from "../../services/axios";
import { useLocation } from "react-router-dom";
import ReactLoading from "react-loading";
import { message, Popconfirm } from "antd";
import url from "../../services/url";
import DatePicker from "react-datepicker";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  useField,
  useFormikContext,
} from "formik";
import { configConsumerProps } from "antd/lib/config-provider";
import Interview from "../../components/Interview";
import isConsultant from "../../services/isConsultant";

const UpcomingInterviewDetail = (props) => {
  const [steps, setSteps] = useState(0);
  const [candidateData, setCandidateData] = useState("");
  const [L1Remarks, setL1Remarks] = useState("");
  const [L2Remarks, setL2Remarks] = useState("");
  const [L3Remarks, setL3Remarks] = useState("");
  const [L1start, setL1start] = useState("");
  const [L1end, setL1end] = useState("");
  const [L2start, setL2start] = useState("");
  const [L2end, setL2end] = useState("");
  const [L3start, setL3start] = useState("");
  const [L3end, setL3end] = useState("");
  const [load, setLoad] = useState(false);
  const [status, setStatus] = useState("");
  const [toggleEditButton, setToggleEditButton] = useState(false);
  const candidateId = localStorage.getItem("candidate.Id");
  const location = useLocation();
  const candidateRouteData = location.state;
  // console.log("state", candidateRouteData);

  const DatePickerField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    return (
      <DatePicker
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(val) => {
          setFieldValue(field.name, val);
          console.log("ssssssssss", val);
        }}
      />
    );
  };

  const success = (e) => {
    console.log(e);
    if (e === "submit") {
      message.success("Feedback submitted , Successfully!", 5);
    } else if (e === "submitRescheduleInterview") {
      message.success("Interview Rescheduled, Successfully!", 5);
    } else {
      message.success("Feedback edit Form, Opened!", 5);
    }
  };

  const cancel = (e) => {
    console.log(e);
    message.error("Cancelled");
  };

  useEffect(() => {
    getCandidateDetails();
    getInterviewDetails();
    interviewAccessFunction();
  }, []);

  const [enable, setEnable] = useState(false);
  const interviewAccessFunction = () => {
    setEnable(false);
    if (candidateRouteData.interviewAccess === "upcoming") {
      setEnable(true);
    }
  };
  const [pdf, setPdf] = useState();
  const getCandidateDetails = () => {
    setLoad(true);
    axios
      .get("/candidates/" + candidateId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setCandidateData(res.data);
        const pdfData = res?.data?.files?.filter((ele) => {
          return ele?.fieldname === "resume";
        });

        const link = url("/uploads/") + pdfData[0]?.filename;
        console.log("link data", link);
        setPdf(link);
        stepsProgressCount(res.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [interview, setInterview] = useState("");
  const [interviewFinished, setInterviewFinished] = useState();
  const [stepsVersantVisibile, setStepsVersantVisible] = useState("");

  const getInterviewDetails = () => {
    setLoad(true);
    axios
      .put(
        "/interviews",
        {
          candidate: candidateId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        console.log("interveiwsss", res.data);
        setStepsVersantVisible(res.data[2].type);
        const filterClientRound = res?.data?.filter((ele) => {
          return ele.type === "clientRound";
        });
        console.log("fiter client", filterClientRound);
        setInterview(filterClientRound[0]);
        setInterviewFinished(filterClientRound[0]?.finished);
        infoTipsRemarks(res);
        setRemarks(filterClientRound[0].remarks);
        setStatus(filterClientRound[0].status);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const stepsProgressCount = (data) => {
    if (candidateRouteData.day === "Completed") {
      setSteps(4);
    } else if (data.L3_Status === "Selected") {
      setSteps(3);
    } else if (data.L2_Status === "Selected") {
      setSteps(2);
    } else if (data.L1_Status === "Selected") {
      setSteps(1);
    } else {
      setSteps(0);
    }
  };
  const infoTipsRemarks = (res) => {
    if (res.data[2].type === "final") {
      setL3Remarks(res.data[2].remarks);
      setL3start(res.data[2].start);
      setL3end(res.data[2].end);
    }
    if (res.data[1].type === "L2") {
      setL2Remarks(res.data[1].remarks);
      setL2start(res.data[1].start);
      setL2end(res.data[1].end);
    }
    if (res.data[0].type === "L1") {
      setL1Remarks(res.data[0].remarks);
      setL1start(res.data[0].start);
      setL1end(res.data[0].end);
    }
  };
  console.log("versant", stepsVersantVisibile);
  const { Step } = Steps;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { Panel } = Collapse;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offSet) {
    setPageNumber((prevPageNumber) => prevPageNumber + offSet);
  }

  function changePageBack() {
    changePage(-1);
  }

  function changePageNext() {
    changePage(+1);
  }

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  //SUBMIT YOUR FEEDBACK MODULE
  const [communicationRating, setCommunicationRating] = useState({
    name: "Communication",
    rating: 0,
    review: "",
  }); // initial rating value
  const [stabilityRating, setStabilityRating] = useState({
    name: "Stability",
    rating: 0,
    review: "",
  });
  const [logicalRating, setLogicalRating] = useState({
    name: "Logical index",
    rating: 0,
    review: "",
  });
  const [confidenceRating, setConfidenceRating] = useState({
    name: "Confidence level",
    rating: 0,
    review: "",
  });
  const [technicalRating, setTechnicalRating] = useState({
    name: "Technical skills",
    rating: 0,
    review: "",
  });

  // Catch Rating value
  const handleCommunicationRating = (rate) => {
    console.log("1rating", rate);
    const ratingData = { name: "Communication", rating: rate, review: "" };
    setCommunicationRating(ratingData);
    // other logic
  };
  const handleStabilityRating = (rate) => {
    console.log("2rating", rate);
    const ratingData = { name: "Stability", rating: rate, review: "" };
    setStabilityRating(ratingData);
    // other logic
  };
  const handleLogicalRating = (rate) => {
    console.log("3rating", rate);
    const ratingData = { name: "Logical index", rating: rate, review: "" };
    setLogicalRating(ratingData);
    // other logic
  };
  const handleConfidenceRating = (rate) => {
    console.log("4rating", rate);
    const ratingData = { name: "Confidence level", rating: rate, review: "" };
    setConfidenceRating(ratingData);
    // other logic
  };
  const handleTechnicalRating = (rate) => {
    console.log("4rating", rate);
    const ratingData = { name: "Technical skills", rating: rate, review: "" };
    setTechnicalRating(ratingData);
    // other logic
  };

  //Assign task -in feedback module-currently not using this feature
  // const [assignTask, setAssignTask] = useState("");

  // const handleAssignTask = (data) => {
  //   console.log("data", data);
  //   setAssignTask(data);
  // };

  const handleStatus = (e) => {
    console.log("value", e.target.value);
    setStatus(e.target.value);
  };

  const [remarks, setRemarks] = useState("");
  const handleRemarks = (e) => {
    console.log("value", e.target.value);
    setRemarks(e.target.value);
  };
  const [errorRemarks, setErrorRemarks] = useState("");
  const submitYourFeedback = (e) => {
    e.preventDefault();
    if (
      (status === "Selected" || status === "Pending") &&
      !confidenceRating.rating &&
      !logicalRating.rating &&
      !stabilityRating.rating &&
      !communicationRating.rating
    ) {
      setErrorRemarks("Ratings are required in case of Selected status");
    } else if (status === "Pending") {
      setErrorRemarks("Status is required");
    } else {
      setErrorRemarks("");
      const FeedbackData = {
        finished: true,
        rating: [
          confidenceRating,
          logicalRating,
          stabilityRating,
          communicationRating,
          technicalRating,
        ],
        status: status,
        remarks: remarks,
        rejectionReason: "",
        typingTest: false,
        typingTestRemarks: "",
        versantScore: false,
        versantScoreRemarks: "",
        clientRound: false,
        clientRoundResult: "",
        L4AttemptBy: localStorage.getItem("user.id"),
      };

      axios
        .patch("/interviews/" + interview._id, FeedbackData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        })
        .then((res) => {
          console.log("questionsss", res.data);
          window.location.reload();
          success("submit");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  //EDIT FEEDBACK
  const editFeedback = (e) => {
    e.preventDefault();
    axios
      .patch(
        "interviews/InterviewStatus/" + interview._id,
        { finished: false },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        console.log("questionsss", res.data);
        window.location.reload();
        success("edit");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const [startDate, setStartDate] = useState("");
  // const handleStartDate = (e) => {

  //   setStartDate(e.target.value);
  // };

  //REQUEST FOR RESCHEDULE MODULE
  let initialValues = {
    start: new Date(),
    end: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      new Date().getHours(),
      new Date().getMinutes() + 30
    ),
  };
  const [date, setDate] = useState();
  const handleDate = (e) => {
    setDate(e);
  };

  const [rescheduleRemarks, setRescheduleRemarks] = useState("");

  const handleRescheduleRemarks = (e) => {
    setErrorMessageReschedule("");
    setRescheduleRemarks(e.target.value);
  };
  const [errorDateReschedule, setErrorDateReschedule] = useState("");
  const [errorMessageReschedule, setErrorMessageReschedule] = useState("");

  const submitRescheduleInterview = (e) => {
    e.preventDefault();
    const rescheduleData = {
      ReScheduleStartDateTime: date.start,
      ReScheduleEndDateTime: date.end,
      Remarks: rescheduleRemarks,
    };
    if (date.start === "" || date.end === "") {
      setErrorDateReschedule("Date is Required");
    }
    if (rescheduleData.Remarks === "") {
      setErrorMessageReschedule("Message is required");
    }
    if (rescheduleRemarks !== "") {
      axios
        .post(
          "/interviews/RescheduleInterview/" + interview._id,
          rescheduleData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          window.location.reload();
          success("submitRescheduleInterview");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // console.log("status", interview.status);
  return (
    <div>
    {!isConsultant() && <div className="client-upcoming-interview">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Dashboard title="Customer Support Executive Interview">
        <span className="navbar-brand mb-2">
          Customer Support Executive Interview
        </span>

        <div className="container">
          <div className="row shadow-sm p-4 my-4 bg-white">
            <div className="col-lg-2 p-0 my-lg-0 my-2">
              <h5 className="font-weight-bold mb-1">{candidateData.name}</h5>
              <p className="text-gray mb-0 d-flex align-items-center">
                <i class="fa fa-phone mr-1" aria-hidden="true"></i>
                {candidateData.mobileNo}
              </p>
              <p className="text-gray mb-0 d-flex align-items-center">
                <i class="fa fa-envelope mr-1" aria-hidden="true"></i>
                {candidateData.email}
              </p>
            </div>
            <div className="col-lg-10 p-0 my-lg-0 my-2">
              <Steps
                current={steps}
                percent={60}
                size="small"
                labelPlacement="vertical"
              >
                <Step
                  title="HR Round"
                  description={
                    <Tooltip
                      title={
                        <div>
                          {L1Remarks ? (
                            <p>Remarks:-{L1Remarks}</p>
                          ) : (
                            "No Remarks"
                          )}

                          {/* <p>Start:-{L1start}</p>
                          <p>End:-{L1end}</p> */}
                        </div>
                      }
                    >
                      <InfoCircleFilled />
                    </Tooltip>
                  }
                />
                <Step
                  title="Functional Round"
                  description={
                    <Tooltip
                      title={
                        <div>
                          {L2Remarks ? (
                            <p>Remarks:-{L2Remarks}</p>
                          ) : (
                            "No Remarks"
                          )}
                          {/* <p>Start:-{L2start}</p>
                          <p>End:-{L2end}</p> */}
                        </div>
                      }
                    >
                      <InfoCircleFilled />
                    </Tooltip>
                  }
                />
                {stepsVersantVisibile === "versant" && (
                  <Step
                    title="Versant round"
                    description={
                      <Tooltip
                        title={
                          <div>
                            {L3Remarks ? (
                              <p>Remarks:-{L3Remarks}</p>
                            ) : (
                              "No Remarks"
                            )}
                            {/* <p>Start:-{L3start}</p>
                          <p>End:-{L3end}</p> */}
                          </div>
                        }
                      >
                        <InfoCircleFilled />
                      </Tooltip>
                    }
                  />
                )}
                <Step
                  title="Interview"
                  subTitle={
                    candidateRouteData.day + " " + candidateRouteData.date
                  }
                  description={
                    <Tooltip title="Request for Reschedule">
                      {candidateRouteData.day !== "Completed" && (
                        <CalendarFilled onClick={showModal} />
                      )}
                    </Tooltip>
                  }
                />

                {/* <Step title="Offer Letter" description="" /> */}
              </Steps>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12 padding-l">
              <Card className="shadow-sm mb-4 bg-white" title="Attachment">
                {/* <div className="d-flex align-items-center justify-content-between overflow-hidden">
                  <div className="resume ">
                    <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                    <span> Navdeepsingh_sr_designer_resume.pdf</span>
                  </div>
                  <i class="fa fa-file" aria-hidden="true"></i>
                </div> */}
                <Collapse ghost>
                  {pdf === url("/uploads/") + "undefined" ? (
                    <Panel
                      header={
                        <div>
                          {" "}
                          <div className="d-flex align-items-center justify-content-between overflow-hidden">
                            <div className="resume ">
                              <i
                                class="fa fa-paperclip mr-2"
                                aria-hidden="true"
                              ></i>
                              <span>{candidateData.name}@resume.pdf</span>
                            </div>
                          </div>
                        </div>
                      }
                      key="1"
                    >
                      <header className="App-header">
                        <p
                          style={{ color: "red" }}
                          className="font-weight-bold pb-3"
                        >
                          PDF not available
                        </p>
                      </header>
                    </Panel>
                  ) : (
                    <Panel
                      header={
                        <div>
                          {" "}
                          <div className="d-flex align-items-center justify-content-between overflow-hidden">
                            <div className="resume ">
                              <i
                                class="fa fa-paperclip mr-2"
                                aria-hidden="true"
                              ></i>
                              <span>{candidateData.name}@resume.pdf</span>
                            </div>
                          </div>
                        </div>
                      }
                      key="1"
                    >
                      <header className="App-header">
                        <Document
                          file={pdf}
                          onLoadSuccess={onDocumentLoadSuccess}
                        >
                          <Page height="600" pageNumber={pageNumber} />
                        </Document>
                        <p>
                          {" "}
                          Page {pageNumber} of {numPages}
                        </p>
                        {pageNumber > 1 && (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={changePageBack}
                          >
                            Previous Page
                          </button>
                        )}
                        {pageNumber < numPages && (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={changePageNext}
                          >
                            Next Page
                          </button>
                        )}
                      </header>
                    </Panel>
                  )}
                </Collapse>
              </Card>
              <Card
                className="shadow-sm mb-4 bg-white"
                title="Candidate Details"
              >
                <div className="details">
                  {candidateData?.responses?.map((ele, i) => {
                    return (
                      <div key={i}>
                        <p>
                          <b>{ele.label}</b> - {ele.value}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </Card>
            </div>
            <div className="col-lg-6 col-12 padding-r">
              <Card
                className="shadow-sm mb-4 bg-white"
                title="Share Your Feedback"
              >
                {/* <div className="row mb-3">
                  <div className="col-lg-12">
                    <div className="customSelect">
                      <select id="FormType" className="my-2 form-control ">
                        <option value>Select Status</option>
                        <option value="">Interview Completed</option>
                        <option value="">Interview InCompleted</option>
                      </select>
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-lg-12 mb-2">
                    <h6 className="process-text">
                      Process- {candidateRouteData.processName}
                    </h6>
                  </div>
                </div>
                {/* <div className="row mb-3">
                  <div className="col-lg-12">
                    <div className="customSelect">
                      <select id="FormType" className="my-2 form-control ">
                        <option value>Select Status</option>
                        <option value="">Interview Completed</option>
                        <option value="">Interview InCompleted</option>
                      </select>
                    </div>
                  </div>
                </div> */}

                <div className="row">
                  <div className="col-lg-4 mb-2">
                    {interviewFinished ? (
                      <h6>{interview?.rating[0]?.name}</h6>
                    ) : (
                      <h6>Communication :- </h6>
                    )}
                  </div>
                  <div className="col-lg-8 mb-2">
                    {/* <StarRating
                      starRatedColor="#4e73df"
                      starDimension="25px"
                      starSpacing="10px"
                    /> */}
                    {interviewFinished ? (
                      <p>{interview?.rating[0]?.rating} </p>
                    ) : (
                      <Rate
                        disabled={enable}
                        defaultValue={0}
                        onChange={handleCommunicationRating}
                      />
                    )}
                  </div>
                  <div className="col-lg-4 mb-2">
                    {interviewFinished ? (
                      <h6>{interview?.rating[1]?.name}</h6>
                    ) : (
                      <h6>Stability :- </h6>
                    )}
                  </div>
                  <div className="col-lg-8 mb-2">
                    {/* <StarRating
                      starRatedColor="#4e73df"
                      starDimension="25px"
                      starSpacing="10px"
                    /> */}
                    {interviewFinished ? (
                      <p>{interview?.rating[1]?.rating} </p>
                    ) : (
                      <Rate
                        disabled={enable}
                        defaultValue={0}
                        onChange={handleStabilityRating}
                      />
                    )}
                  </div>
                  <div className="col-lg-4 mb-2">
                    {interviewFinished ? (
                      <h6>{interview?.rating[2]?.name}</h6>
                    ) : (
                      <h6>Logical Index :- </h6>
                    )}
                  </div>
                  <div className="col-lg-8 mb-2">
                    {/* <StarRating
                      starRatedColor="#4e73df"
                      starDimension="25px"
                      starSpacing="10px"
                    /> */}
                    {interviewFinished ? (
                      <p>{interview?.rating[2]?.rating} </p>
                    ) : (
                      <Rate
                        disabled={enable}
                        defaultValue={0}
                        onChange={handleLogicalRating}
                      />
                    )}
                  </div>
                  <div className="col-lg-4 mb-2">
                    {interviewFinished ? (
                      <h6>{interview?.rating[3]?.name}</h6>
                    ) : (
                      <h6>Confidence Level :- </h6>
                    )}
                  </div>
                  <div className="col-lg-8 mb-2">
                    {/* <StarRating
                      starRatedColor="#4e73df"
                      starDimension="25px"
                      starSpacing="10px"
                    /> */}
                    {interviewFinished ? (
                      <p>{interview?.rating[3]?.rating} </p>
                    ) : (
                      <Rate
                        disabled={enable}
                        defaultValue={0}
                        onChange={handleConfidenceRating}
                      />
                    )}
                  </div>
                  <div className="col-lg-4 mb-2">
                    {interviewFinished ? (
                      <h6>{interview?.rating[4]?.name}</h6>
                    ) : (
                      <h6>Technical Skills :- </h6>
                    )}
                  </div>
                  <div className="col-lg-8 mb-2">
                    {/* <StarRating
                      starRatedColor="#4e73df"
                      starDimension="25px"
                      starSpacing="10px"
                    /> */}
                    {interviewFinished ? (
                      <p>{interview?.rating[4]?.rating} </p>
                    ) : (
                      <Rate
                        disabled={enable}
                        defaultValue={0}
                        onChange={handleTechnicalRating}
                      />
                    )}
                  </div>

                  {interviewFinished ? (
                    <div className="col-12 mt-2 d-flex align-items-center gap-3">
                      <h5 className="m-0">Status:-</h5>
                      <p className="m-0">{interview.status}</p>
                    </div>
                  ) : (
                    <div className="col-lg-8 mb-2">
                      <Radio.Group
                        value={status}
                        disabled={enable}
                        onChange={handleStatus}
                      >
                        <Radio value={"Selected"}>
                          <h6>Selected</h6>
                        </Radio>
                        <Radio value={"On Hold"}>
                          <h6>On Hold</h6>
                        </Radio>
                        <Radio value={"Rejected"}>
                          <h6>Rejected</h6>
                        </Radio>
                        {/* <Radio value={"Not Connected"}>
                          <h6>Not Connected</h6>
                        </Radio> */}
                        {/* <Radio value={"Pending"}>
                          <h6>Pending</h6>
                        </Radio> */}
                      </Radio.Group>
                    </div>
                  )}
                  <div className="col-12 mt-3">
                    {interviewFinished ? (
                      <div className="d-flex align-items-center gap-3 flex-wrap">
                        <h5 className="m-0">Remarks:-</h5>
                        <p className="m-0">{interview.remarks}</p>
                      </div>
                    ) : (
                      <div>
                        <textarea
                          disabled={enable}
                          value={remarks}
                          onChange={handleRemarks}
                          placeholder="Remarks..."
                          class="form-control mb-3"
                          rows="3"
                        />{" "}
                        {errorRemarks && (
                          <div
                            className="text-danger"
                            style={{ marginTop: 5 + "px" }}
                          >
                            {errorRemarks}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className="row align-items-center my-2">
                  <div className="col-lg-4 my-2">
                    <h6 className="mb-0">Assign any task?</h6>
                  </div>
                  <div className="col-lg-8 my-2">
                    <Radio.Group>
                      <Radio
                        value={"yes"}
                        onClick={() => {
                          handleAssignTask("yes");
                        }}
                      >
                        <h6>Yes</h6>
                      </Radio>
                      <Radio
                        value={"no"}
                        onClick={() => {
                          handleAssignTask("no");
                        }}
                      >
                        <h6>No</h6>
                      </Radio>
                    </Radio.Group>
                  </div>
                </div>
                {assignTask === "yes" && (
                  <div className="row align-items-center my-2">
                    <div className="col-lg-4 my-2">
                      <h6 className="mb-0">Attachment</h6>
                    </div>
                    <div className="col-lg-8 my-2">
                      <button className="btn browse-btn" type="file">
                        Browse
                      </button>
                    </div>
                  </div>
                )} */}

                <div className="col-lg-12 my-3 mt-4 p-0 d-flex justify-content-end">
                  {/* {interviewFinished ? (
                    <Popconfirm
                      title="Are you sure to Edit the Feedback ?"
                      onConfirm={editFeedback}
                      onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <button
                        className="btn submit-btn-outline"
                        // onClick={editFeedback}
                      >
                        Edit
                      </button>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Are you sure to Submit the Feedback ?"
                      onConfirm={submitYourFeedback}
                      onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <button
                        disabled={enable}
                        className="btn submit-btn-outline"
                      >
                        Submit
                      </button>
                    </Popconfirm>
                  )} */}

                  {(interview?.status === "Pending" ||
                    interview?.status === "On Hold") &&
                    interview.finished && (
                      <Popconfirm
                        title="Are you sure to Edit the Feedback ?"
                        onConfirm={editFeedback}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >
                        <button
                          className="btn submit-btn-outline"
                          // onClick={editFeedback}
                        >
                          Edit
                        </button>
                      </Popconfirm>
                    )}

                  {!interviewFinished && (
                    <Popconfirm
                      title="Are you sure to Submit the Feedback ?"
                      onConfirm={submitYourFeedback}
                      onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      disabled={enable}
                    >
                      <button
                        disabled={enable}
                        className="btn submit-btn-outline"
                      >
                        Submit
                      </button>
                    </Popconfirm>
                  )}
                </div>
              </Card>
            </div>
          </div>
          <div className="row">
            <div className="col-12 p-0">
              <Card className="shadow-sm mb-4 bg-white" title="Job Description">
                <p>
                  <a
                    href="https://maxicus.com/career/quality-auditor-2/"
                    target="blank"
                  >
                    View
                  </a>
                </p>
              </Card>
            </div>
          </div>
        </div>
      </Dashboard>

      <Modal
        className="request-modal"
        title={
          <h5 className="font-weight-bold mb-0">Request for Reschedule</h5>
        }
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        onCancel={handleCancel}
      >
        <h6>Round: P1 Interview</h6>
        <div className="my-4">
          {/* <label>Select new start date & time for Reschedule Interview</label> */}
          {/* <RDatePicker
            className="form-control"
            showTimeSelect
            placeholderText="DD/MM/YY : 02:00PM"
            selected={startDate}
            onChange={handleStartDate}
          /> */}
          <Formik
            initialValues={initialValues}
            //onSubmit={onSubmitInterview}
          >
            {(formikProps) => (
              <Form>
                <div className="form-group">
                  <label>
                    Select new start date & time for Reschedule Interview
                  </label>
                  <div>
                    <DatePickerField
                      type="text"
                      className="form-control"
                      name="start"
                      showTimeSelect
                      dateFormat="Pp"
                      popperPlacement="top-end"
                      minDate={new Date()}
                      onChange={handleDate(formikProps.values)}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>
                    Select new end date & time for Reschedule Interview
                  </label>
                  <div>
                    <DatePickerField
                      type="text"
                      className="form-control"
                      name="end"
                      showTimeSelect
                      dateFormat="Pp"
                      popperPlacement="top-end"
                      minDate={new Date()}
                      onChange={handleDate(formikProps.values)}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {errorDateReschedule && (
            <div className="text-danger" style={{ marginTop: 5 + "px" }}>
              {errorDateReschedule}
            </div>
          )}
        </div>
        {/* <div className="my-4">
          <label>Select new end date & time for Reschedule Interview</label>
          <RDatePicker
            className="form-control"
            showTimeSelect
            placeholderText="DD/MM/YY : 02:00PM"
          />
        </div> */}
        <div className="my-4">
          <label>Message</label>
          <textarea
            value={rescheduleRemarks}
            onChange={handleRescheduleRemarks}
            class="form-control mb-3"
            rows="3"
          />
          {errorMessageReschedule && (
            <div className="text-danger" style={{ marginTop: 5 + "px" }}>
              {errorMessageReschedule}
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end gap-3">
          <button
            onClick={submitRescheduleInterview}
            className="btn submit-btn-outline"
          >
            Submit your request
          </button>
        </div>
      </Modal>
    </div>}
    </div>
  );
};

export default UpcomingInterviewDetail;
